function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import { checkIsGiveawayWithSwagType } from 'swag-common/utils/giveaway/giveaway-type.util';
import { GiveawayLandingComponent } from '../../partials/giveaway-landing/giveaway-landing';
import { goToGiveawaySuccessPage } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { selectedGiveawaySelector, giveawayLinkItemItemSelector, isCurrentGiveawayLandingSubmitButtonDisabledSelector, giveawayTypeLabelLowercaseLandingSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { isImagesInLoadingSelector } from '../../../redux/image-loading/image-loading.selectors';
import { showLoadingOverlaySelector } from '../../../redux/common/common.selectors';
const goodieGiveawayStepSelector = createSelector(selectedGiveawaySelector, giveaway => {
  if (!giveaway || checkIsGiveawayWithSwagType(giveaway)) {
    return null;
  }
  return GiveawayGoodieSteps.catalog;
});
const mapStateToProps = () => {
  return createStructuredSelector({
    giveaway: selectedGiveawaySelector,
    isImagesInLoading: isImagesInLoadingSelector,
    disabled: isCurrentGiveawayLandingSubmitButtonDisabledSelector,
    step: goodieGiveawayStepSelector,
    link: giveawayLinkItemItemSelector,
    giveawayTypeLabel: giveawayTypeLabelLowercaseLandingSelector,
    isLoading: showLoadingOverlaySelector,
    submitButtonColor: selectedGiveawayColorWithFallbackSelector
  });
};
const mapDispatchToProps = dispatch => bindActionCreators({
  onSubmit: goToGiveawaySuccessPage
}, dispatch);
const connectedComponent = connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => {
  const giveaway = stateProps.giveaway;
  const onSubmit = giveaway ? dispatchProps.onSubmit.bind(undefined, String(giveaway.inventoryId), giveaway._id) : () => null;
  return _objectSpread({}, stateProps, {
    onSubmit
  });
})(GiveawayLandingComponent);
export const GiveawayLandingAdmin = connectedComponent;